import React from 'react';

import './AuthorInfo.css'

const AuthorInfo = ({ resultType, blogAuthor, blogPublishedString }) => {
  return (
    resultType === 'Blog' && blogAuthor ? (
      <div className="author-info">
        {blogPublishedString} by {blogAuthor}
      </div>
    ) : null
  );
};

export default AuthorInfo;
